import { Box, Button, Card, CardContent, Typography } from '@mui/material'
import { useMemo } from 'react'
import GenericEmrSubSectionComponent from 'src/mentor/components/EmrRelatedComponents/components/GenericEmrSubSectionComponent'
import EmrSectionActionsGroup from 'src/mentor/components/EmrRelatedComponents/components/EmrSectionActionsGroup'
import { generateItemTitle } from 'src/mentor/components/EmrRelatedComponents/utils/subSectionHandlerUtils'

/**
 * Renders repeatable subsections where each subsection can have multiple items.
 * Each item is displayed as a card with its own fields and actions.
 *
 * Actions are passed as a prop for flexibility - caller can provide either:
 * - subSection.actions (subsection-level)
 * - section.actions (section-level)
 * - merged/fallback logic
 */
// export default function RepeatableActionSubSection({
//   subSection,
//   subSectionsData,
//   setSubSectionsData,
//   actions = [], // Flexible action source - can be switched by caller
//   practitionerRole,
//   runtime,
// }) {
//   const collectionKey = subSection?.collectionKey || 'items'
//   const itemTitleTemplate = subSection?.itemTitleTemplate
//   const minItems = subSection?.minItems || 0
//   const maxItems = subSection?.maxItems || 100

//   // Extract layout config from subsection definition
//   const layout = subSection?.layoutConfig?.type || 'grid'
//   const columns = subSection?.layoutConfig?.columns || 3
//   const spacing = subSection?.layoutConfig?.spacing || 2

//   // Get current subsection data
//   const currentSubSectionData = useMemo(() => {
//     return subSectionsData?.find((data) => data?.subSectionCode === subSection?.code)
//   }, [subSectionsData, subSection?.code])

//   // Get items array from values[collectionKey]
//   const items = useMemo(() => {
//     return currentSubSectionData?.values?.[collectionKey] || []
//   }, [currentSubSectionData, collectionKey])

//   // Helper: Get field value from item
//   const getFieldValue = (item, fieldCode, fieldType) => {
//     const emrValue = item?.[fieldCode]
//     if (!emrValue) return getDefaultValue(fieldCode, fieldType)

//     switch (fieldType) {
//       case 'TEXT':
//       case 'TEXTAREA':
//         return emrValue.valueString || ''
//       case 'NUMBER':
//         return emrValue.valueNumber ?? ''
//       case 'BOOLEAN':
//         return emrValue.valueBoolean ?? false
//       case 'DATE':
//       case 'TIME':
//       case 'DATETIME':
//         return emrValue.valueDate || null
//       case 'SELECT_ONE':
//         return emrValue.code || ''
//       case 'SELECT_MULTI':
//         return emrValue.valueStringList || []
//       default:
//         return ''
//     }
//   }

//   // Helper: Get default value for a field
//   const getDefaultValue = (fieldCode, fieldType) => {
//     const field = subSection?.fields?.find((f) => f.code === fieldCode)
//     if (!field) return null

//     switch (fieldType) {
//       case 'TEXT':
//       case 'TEXTAREA':
//         return field.defaultString || ''
//       case 'NUMBER':
//         return field.defaultNumber ?? ''
//       case 'BOOLEAN':
//         return field.defaultBoolean ?? false
//       case 'DATE':
//       case 'TIME':
//       case 'DATETIME':
//         return field.defaultDate || null
//       case 'SELECT_ONE':
//         return field.defaultCode || ''
//       case 'SELECT_MULTI':
//         return []
//       default:
//         return null
//     }
//   }

//   // Helper: Update field value in a specific item
//   const updateItemFieldValue = (
//     itemIndex,
//     fieldCode,
//     value,
//     fieldType,
//     displayValue = null,
//     fieldLabel = null,
//   ) => {
//     setSubSectionsData((prevData) => {
//       const existingSubSection = prevData?.find((data) => data?.subSectionCode === subSection?.code)

//       const emrValue = (existingSubSection.values || {})?.[fieldCode] || {}

//       switch (fieldType) {
//         case 'TEXT':
//         case 'TEXTAREA':
//           emrValue.valueString = value
//           break
//         case 'NUMBER':
//           emrValue.valueNumber = value === '' ? null : Number(value)
//           break
//         case 'BOOLEAN':
//           emrValue.valueBoolean = value
//           break
//         case 'DATE':
//         case 'TIME':
//         case 'DATETIME':
//           emrValue.valueDate = value
//           break
//         case 'SELECT_ONE':
//           emrValue.code = value
//           emrValue.display = displayValue
//           break
//         case 'SELECT_MULTI':
//           // For QUERY/HYBRID, value is already an array of EmrValueItem objects
//           // For STATIC/VALUE_SET, value is an array of codes
//           if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'object') {
//             emrValue.valueStringList = value // Already EmrValueItem[]
//           } else {
//             emrValue.valueStringList = value // Array of codes (STATIC/VALUE_SET)
//           }
//           break
//       }

//       // Add title to emrValue if fieldLabel is provided
//       if (fieldLabel) {
//         emrValue.title = fieldLabel
//       }

//       setSubSectionsData((prev) => ({
//         ...prev,
//         values: { ...(prev?.values || {}), [fieldCode]: emrValue },
//       }))
//     })
//   }

//   // Helper: Add a new empty item
//   const addNewItem = () => {
//     if (items.length >= maxItems) return

//     setSubSectionsData((prevData) => {
//       const existingSubSection = prevData?.find((data) => data?.subSectionCode === subSection?.code)
//       const newItem = {} // Empty item, will be filled by user

//       if (existingSubSection) {
//         return prevData.map((data) => {
//           if (data.subSectionCode === subSection?.code) {
//             return {
//               ...data,
//               values: {
//                 ...data.values,
//                 [collectionKey]: [...(data.values?.[collectionKey] || []), newItem],
//               },
//             }
//           }
//           return data
//         })
//       } else {
//         return [
//           ...(prevData || []),
//           {
//             subSectionCode: subSection?.code,
//             title: subSection?.title,
//             values: {
//               [collectionKey]: [newItem],
//             },
//           },
//         ]
//       }
//     })
//   }

//   // Helper: Remove an item
//   const removeItem = (itemIndex) => {
//     if (items.length <= minItems) return

//     setSubSectionsData((prevData) => {
//       return prevData.map((data) => {
//         if (data.subSectionCode === subSection?.code) {
//           const updatedItems = [...(data.values?.[collectionKey] || [])]
//           updatedItems.splice(itemIndex, 1)
//           return {
//             ...data,
//             values: {
//               ...data.values,
//               [collectionKey]: updatedItems,
//             },
//           }
//         }
//         return data
//       })
//     })
//   }

//   // Helper: Check if field should be shown based on showIf conditions
//   const shouldShowField = (field, item) => {
//     if (!field?.showIf || field.showIf.length === 0) return true

//     return field.showIf.every((condition) => {
//       const dependentFieldValue = getFieldValue(item, condition.fieldCode, null)
//       const { op, code, codes, stringValue, numberValue, booleanValue } = condition

//       switch (op) {
//         case 'EQ':
//           if (code !== undefined) return dependentFieldValue === code
//           if (stringValue !== undefined) return dependentFieldValue === stringValue
//           if (numberValue !== undefined) return dependentFieldValue === numberValue
//           if (booleanValue !== undefined) return dependentFieldValue === booleanValue
//           return false

//         case 'NEQ':
//           if (code !== undefined) return dependentFieldValue !== code
//           if (stringValue !== undefined) return dependentFieldValue !== stringValue
//           if (numberValue !== undefined) return dependentFieldValue !== numberValue
//           if (booleanValue !== undefined) return dependentFieldValue !== booleanValue
//           return false

//         case 'IN':
//           return codes?.includes(dependentFieldValue)

//         case 'NOT_IN':
//           return !codes?.includes(dependentFieldValue)

//         case 'GT':
//           return numberValue !== undefined && dependentFieldValue > numberValue

//         case 'GTE':
//           return numberValue !== undefined && dependentFieldValue >= numberValue

//         case 'LT':
//           return numberValue !== undefined && dependentFieldValue < numberValue

//         case 'LTE':
//           return numberValue !== undefined && dependentFieldValue <= numberValue

//         case 'EXISTS':
//           return dependentFieldValue != null && dependentFieldValue !== ''

//         case 'TRUE':
//           return dependentFieldValue === true

//         case 'FALSE':
//           return dependentFieldValue === false

//         default:
//           return true
//       }
//     })
//   }

//   // Helper: Get options for SELECT fields
//   const getFieldOptions = (field) => {
//     const optionSource = field?.optionSource

//     // STATIC and VALUE_SET: use staticOptions (server hydrates VALUE_SET to staticOptions)
//     if (optionSource?.type === 'STATIC' || optionSource?.type === 'VALUE_SET') {
//       return optionSource?.staticOptions || []
//     }

//     // QUERY and HYBRID: handled by specialized components (return empty here)
//     if (optionSource?.type === 'QUERY' || optionSource?.type === 'HYBRID') {
//       return []
//     }

//     // Fallback for undefined/null optionSource (backward compatibility)
//     return []
//   }

//   // Render field for an item
//   const renderField = (field, item, itemIndex) => {
//     if (!shouldShowField(field, item)) return null

//     const value = getFieldValue(item, field.code, field.type)

//     switch (field.type) {
//       case 'TEXT':
//         return (
//           <div
//             key={field.code}
//             style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}
//           >
//             <PMPSectionInputLabel>{field.label}</PMPSectionInputLabel>
//             <PMPSectionInputBox
//               value={value}
//               onChange={(e) =>
//                 updateItemFieldValue(
//                   itemIndex,
//                   field.code,
//                   e.target.value,
//                   field.type,
//                   null,
//                   field.label,
//                 )
//               }
//               placeholder={field.placeholder}
//               disabled={field.readOnly}
//               required={field.required}
//               minLength={field.minLength}
//               maxLength={field.maxLength}
//               pattern={field.regex}
//             />
//           </div>
//         )

//       case 'TEXTAREA':
//         return (
//           <div
//             key={field.code}
//             style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}
//           >
//             <PMPSectionInputLabel>{field.label}</PMPSectionInputLabel>
//             <PMPSectionTextAreaBox
//               value={value}
//               onChange={(e) =>
//                 updateItemFieldValue(
//                   itemIndex,
//                   field.code,
//                   e.target.value,
//                   field.type,
//                   null,
//                   field.label,
//                 )
//               }
//               placeholder={field.placeholder}
//               disabled={field.readOnly}
//               required={field.required}
//               minLength={field.minLength}
//               maxLength={field.maxLength}
//               minRows={1}
//             />
//           </div>
//         )

//       case 'NUMBER':
//         return (
//           <div
//             key={field.code}
//             style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}
//           >
//             <PMPSectionInputLabel>{field.label}</PMPSectionInputLabel>
//             <div style={{ position: 'relative', width: '100%' }}>
//               <PMPSectionInputBox
//                 style={{ maxWidth: 'unset' }}
//                 type="number"
//                 value={value}
//                 onChange={(e) =>
//                   updateItemFieldValue(
//                     itemIndex,
//                     field.code,
//                     e.target.value,
//                     field.type,
//                     null,
//                     field.label,
//                   )
//                 }
//                 placeholder={field.placeholder}
//                 disabled={field.readOnly}
//                 required={field.required}
//                 min={field.minNumber}
//                 max={field.maxNumber}
//               />
//               {field.unit && (
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   style={{
//                     position: 'absolute',
//                     right: '10px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                   }}
//                 >
//                   {field.unit}
//                 </Typography>
//               )}
//             </div>
//           </div>
//         )

//       case 'BOOLEAN':
//         return (
//           <FormControlLabel
//             key={field.code}
//             control={
//               <Checkbox
//                 checked={value}
//                 onChange={(e) =>
//                   updateItemFieldValue(
//                     itemIndex,
//                     field.code,
//                     e.target.checked,
//                     field.type,
//                     null,
//                     field.label,
//                   )
//                 }
//                 disabled={field.readOnly}
//               />
//             }
//             label={field.label}
//           />
//         )

//       case 'DATE':
//         return (
//           <div
//             key={field.code}
//             style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}
//           >
//             <PMPSectionInputLabel>{field.label}</PMPSectionInputLabel>
//             <DatePicker
//               value={value}
//               onChange={(newValue) =>
//                 updateItemFieldValue(itemIndex, field.code, newValue, field.type, null, field.label)
//               }
//               disabled={field.readOnly}
//               slotProps={{
//                 textField: {
//                   fullWidth: true,
//                   required: field.required,
//                   helperText: field.helpText,
//                 },
//               }}
//             />
//           </div>
//         )

//       case 'TIME':
//         return (
//           <div
//             key={field.code}
//             style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}
//           >
//             <PMPSectionInputLabel>{field.label}</PMPSectionInputLabel>
//             <TimePicker
//               value={value}
//               onChange={(newValue) =>
//                 updateItemFieldValue(itemIndex, field.code, newValue, field.type, null, field.label)
//               }
//               disabled={field.readOnly}
//               slotProps={{
//                 textField: {
//                   fullWidth: true,
//                   required: field.required,
//                   helperText: field.helpText,
//                 },
//               }}
//             />
//           </div>
//         )

//       case 'DATETIME':
//         return (
//           <div
//             key={field.code}
//             style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}
//           >
//             <PMPSectionInputLabel>{field.label}</PMPSectionInputLabel>
//             <DateTimePicker
//               value={value}
//               onChange={(newValue) =>
//                 updateItemFieldValue(itemIndex, field.code, newValue, field.type, null, field.label)
//               }
//               disabled={field.readOnly}
//               slotProps={{
//                 textField: {
//                   fullWidth: true,
//                   required: field.required,
//                   helperText: field.helpText,
//                 },
//               }}
//             />
//           </div>
//         )

//       case 'SELECT_ONE': {
//         const optionSource = field?.optionSource

//         // Route to HYBRID component
//         if (optionSource?.type === 'HYBRID') {
//           return (
//             <HybridSelectField
//               key={field.code}
//               field={field}
//               value={value}
//               onChange={(code, display) =>
//                 updateItemFieldValue(itemIndex, field.code, code, field.type, display, field.label)
//               }
//               isMulti={false}
//             />
//           )
//         }

//         // Route to QUERY component
//         if (optionSource?.type === 'QUERY') {
//           return (
//             <AsyncSelectField
//               key={field.code}
//               field={field}
//               value={value}
//               onChange={(code, display) =>
//                 updateItemFieldValue(itemIndex, field.code, code, field.type, display, field.label)
//               }
//               isMulti={false}
//             />
//           )
//         }

//         // Existing STATIC/VALUE_SET logic
//         const options = getFieldOptions(field)
//         const selectOptions = options.map((opt) => ({
//           value: opt.code,
//           label: opt.display || opt.code,
//         }))
//         const selectedOption = selectOptions.find((opt) => opt.value === value)

//         return (
//           <div
//             key={field.code}
//             style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}
//           >
//             <PMPSectionInputLabel>{field.label}</PMPSectionInputLabel>
//             <div style={{ width: '100%' }}>
//               <Select
//                 options={selectOptions}
//                 value={selectedOption}
//                 onChange={(selected) => {
//                   updateItemFieldValue(
//                     itemIndex,
//                     field.code,
//                     selected?.value,
//                     field.type,
//                     selected?.label,
//                     field.label,
//                   )
//                 }}
//                 placeholder={field.placeholder || 'Select...'}
//                 isDisabled={field.readOnly}
//                 isClearable
//                 styles={commonStylesPrescriptionSelect}
//               />
//               {field.helpText && (
//                 <Typography
//                   variant="caption"
//                   color="text.secondary"
//                   sx={{ mt: 0.5, display: 'block' }}
//                 >
//                   {field.helpText}
//                 </Typography>
//               )}
//             </div>
//           </div>
//         )
//       }

//       case 'SELECT_MULTI': {
//         const optionSource = field?.optionSource

//         // Route to HYBRID component
//         if (optionSource?.type === 'HYBRID') {
//           return (
//             <HybridSelectField
//               key={field.code}
//               field={field}
//               value={value}
//               onChangeMulti={(codes, items) => {
//                 // For SELECT_MULTI, updateItemFieldValue expects array of EmrValueItem objects
//                 updateItemFieldValue(itemIndex, field.code, items, field.type, null, field.label)
//               }}
//               isMulti={true}
//             />
//           )
//         }

//         // Route to QUERY component
//         if (optionSource?.type === 'QUERY') {
//           return (
//             <AsyncSelectField
//               key={field.code}
//               field={field}
//               value={value}
//               onChangeMulti={(codes, items) => {
//                 updateItemFieldValue(itemIndex, field.code, items, field.type, null, field.label)
//               }}
//               isMulti={true}
//             />
//           )
//         }

//         // Existing STATIC/VALUE_SET logic
//         const options = getFieldOptions(field)
//         const selectOptions = options.map((opt) => ({
//           value: opt.code,
//           label: opt.display || opt.code,
//         }))
//         const selectedOptions = selectOptions.filter((opt) => value?.includes(opt.value))

//         return (
//           <div
//             key={field.code}
//             style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}
//           >
//             <PMPSectionInputLabel>{field.label}</PMPSectionInputLabel>
//             <div style={{ width: '100%', maxWidth: '700px' }}>
//               <Select
//                 isMulti
//                 options={selectOptions}
//                 value={selectedOptions}
//                 onChange={(selected) => {
//                   const codes = selected ? selected.map((opt) => opt.value) : []
//                   updateItemFieldValue(itemIndex, field.code, codes, field.type, null, field.label)
//                 }}
//                 placeholder={field.placeholder || 'Select...'}
//                 isDisabled={field.readOnly}
//                 isClearable
//                 styles={commonStylesPrescriptionSelect}
//               />
//               {field.helpText && (
//                 <Typography
//                   variant="caption"
//                   color="text.secondary"
//                   sx={{ mt: 0.5, display: 'block' }}
//                 >
//                   {field.helpText}
//                 </Typography>
//               )}
//             </div>
//           </div>
//         )
//       }

//       default:
//         return null
//     }
//   }

//   // Sort fields by sort property
//   const sortedFields = useMemo(() => {
//     return [...(subSection?.fields || [])].sort((a, b) => (a.sort || 0) - (b.sort || 0))
//   }, [subSection?.fields])

//   // Helper: Render action buttons
//   const renderActionButtons = (item, itemIndex) => {
//     if (!actions || actions.length === 0) return null

//     return (
//       <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap' }}>
//         {actions.map((action) => {
//           // Simple role-based filtering
//           if (action.roles && !action.roles.includes(practitionerRole)) {
//             return null
//           }

//           // TODO Phase 2: Implement visibilityWhen/enableWhen expression evaluation
//           // For now, show all actions

//           const handleActionClick = () => {
//             console.log('[RepeatableActionSubSection] Action clicked:', {
//               actionId: action.id,
//               actionLabel: action.label,
//               actionKind: action.kind,
//               itemIndex,
//               item,
//               practitionerRole,
//               runtime,
//             })
//             // TODO Phase 2: Implement full action execution (api, dialog, event, guard)
//             alert(`Action "${action.label}" clicked. Phase 2: Full execution will be implemented.`)
//           }

//           return (
//             <Button
//               key={action.id}
//               variant={action.kind === 'dialog' ? 'outlined' : 'contained'}
//               size="small"
//               onClick={handleActionClick}
//               startIcon={action.icon ? <span>{action.icon}</span> : null}
//             >
//               {action.label || action.id}
//             </Button>
//           )
//         })}
//       </Box>
//     )
//   }

//   // Helper: Generate item title from template
//   const generateItemTitle = (item, itemIndex) => {
//     if (!itemTitleTemplate) return `Item ${itemIndex + 1}`

//     let title = itemTitleTemplate

//     // Find all {{...}} patterns in the template
//     const templatePattern = /\{\{([^}]+)\}\}/g
//     const matches = [...title.matchAll(templatePattern)]

//     matches.forEach((match) => {
//       const expression = match[1].trim() // e.g., "toolIds.join(', ')" or "fieldCode"
//       const placeholder = match[0] // e.g., "{{toolIds.join(', ')}}"

//       // Parse the expression to extract field code and operations
//       // Support patterns like: fieldCode, fieldCode.join(', '), fieldCode.length
//       const methodCallMatch = expression.match(/^(\w+)\.(\w+)\((.*)\)$/)
//       const propertyMatch = expression.match(/^(\w+)\.(\w+)$/)
//       const simpleMatch = expression.match(/^(\w+)$/)

//       let result = ''

//       if (methodCallMatch) {
//         // Handle method calls like: toolIds.join(', ')
//         const fieldCode = methodCallMatch[1]
//         const methodName = methodCallMatch[2]
//         const args = methodCallMatch[3]

//         const field = sortedFields.find((f) => f.code === fieldCode)
//         if (field) {
//           let value = getFieldValue(item, field.code, field.type)

//           // For SELECT_MULTI, value might be an array of codes
//           // We need the display values, not just codes
//           if (field.type === 'SELECT_MULTI' && Array.isArray(value)) {
//             // Get display values if available
//             const itemValue = item?.[field.code]
//             if (Array.isArray(itemValue?.valueStringList)) {
//               // Check if valueStringList contains objects with display property
//               value = itemValue.valueStringList.map((v) => {
//                 if (typeof v === 'object' && v !== null) {
//                   return v.display || v.code || String(v)
//                 }
//                 return String(v)
//               })
//             }
//           }

//           // Apply the method call
//           if (Array.isArray(value) && typeof value[methodName] === 'function') {
//             try {
//               // Parse arguments (e.g., "', '" -> ', ')
//               const parsedArgs = args ? JSON.parse(`[${args}]`) : []
//               result = value[methodName](...parsedArgs)
//             } catch (error) {
//               console.warn(`[generateItemTitle] Error calling ${methodName}:`, error)
//               result = value.toString()
//             }
//           } else {
//             result = value?.toString() || ''
//           }
//         }
//       } else if (propertyMatch) {
//         // Handle property access like: fieldCode.length
//         const fieldCode = propertyMatch[1]
//         const propertyName = propertyMatch[2]

//         const field = sortedFields.find((f) => f.code === fieldCode)
//         if (field) {
//           const value = getFieldValue(item, field.code, field.type)
//           result = value?.[propertyName]?.toString() || ''
//         }
//       } else if (simpleMatch) {
//         // Handle simple field reference: fieldCode
//         const fieldCode = simpleMatch[1]
//         const field = sortedFields.find((f) => f.code === fieldCode)

//         if (field) {
//           const value = getFieldValue(item, field.code, field.type)
//           const displayValue =
//             field.type === 'SELECT_ONE' ? item?.[field.code]?.display || value : value
//           result = displayValue?.toString() || ''
//         }
//       }

//       // Replace the placeholder with the result
//       title = title.replace(placeholder, result)
//     })

//     return title || `Item ${itemIndex + 1}`
//   }

//   if (!subSection) return null

//   return (
//     <Box sx={{ mb: 4 }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography variant="h6">{subSection.title}</Typography>
//         <Button
//           variant="contained"
//           size="small"
//           onClick={addNewItem}
//           disabled={items.length >= maxItems}
//         >
//           Add New
//         </Button>
//       </Box>

//       {items.length === 0 && (
//         <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', mb: 2 }}>
//           No items yet. Click &quot;Add New&quot; to create one.
//         </Typography>
//       )}

//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//         {items.map((item, itemIndex) => (
//           <Card key={itemIndex} variant="outlined">
//             <CardContent>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                   mb: 2,
//                 }}
//               >
//                 <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                   {generateItemTitle(item, itemIndex)}
//                 </Typography>
//                 <Button
//                   variant="outlined"
//                   size="small"
//                   color="error"
//                   onClick={() => removeItem(itemIndex)}
//                   disabled={items.length <= minItems}
//                 >
//                   Remove
//                 </Button>
//               </Box>

//               {/* Render fields based on layout type */}
//               {layout === 'grid' ? (
//                 <Grid container spacing={spacing}>
//                   {sortedFields.map((field) => {
//                     const fieldElement = renderField(field, item, itemIndex)
//                     if (!fieldElement) return null

//                     return (
//                       <Grid item xs={12} sm={12 / columns} md={12 / columns} key={field.code}>
//                         {fieldElement}
//                       </Grid>
//                     )
//                   })}
//                 </Grid>
//               ) : layout === 'row' ? (
//                 <Box sx={{ display: 'flex', flexDirection: 'row', gap: spacing, flexWrap: 'wrap' }}>
//                   {sortedFields.map((field) => {
//                     const fieldElement = renderField(field, item, itemIndex)
//                     if (!fieldElement) return null

//                     return (
//                       <Box key={field.code} sx={{ flex: '1 1 auto', minWidth: '200px' }}>
//                         {fieldElement}
//                       </Box>
//                     )
//                   })}
//                 </Box>
//               ) : (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: spacing }}>
//                   {sortedFields.map((field) => renderField(field, item, itemIndex))}
//                 </Box>
//               )}

//               {renderActionButtons(item, itemIndex)}
//             </CardContent>
//           </Card>
//         ))}
//       </Box>

//       {minItems > 0 && items.length < minItems && (
//         <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
//           Minimum {minItems} item{minItems > 1 ? 's' : ''} required
//         </Typography>
//       )}
//     </Box>
//   )
// }

export default function RepeatableActionSubSectionHandler({
  subSection,
  subSectionDataList,
  setSubSectionsData,
  practitionerRole,
  maxItems = 0,
  minItems = 0,
  runtime,
}) {
  const relevantSubSectionData = (
    (subSectionDataList || []).filter((data) => data?.subSectionCode === subSection?.code) || []
  )
    ?.sort((a, b) => (a.orderNumber || 0) - (b.orderNumber || 0))
    ?.map((data, idx) => ({
      ...data,
      orderNumber: data?.orderNumber || idx,
      state: data.state || 'PENDING', // Default state for action visibility
    }))
  const sortedFields = useMemo(() => {
    return subSection?.fields || []
  }, [subSection?.fields])
  function setRelevantSubSectionData(updaterOrData, itemIndex) {
    setSubSectionsData((fullSubSectionsList) => {
      // Find the specific item to update
      const targetItem = fullSubSectionsList
        ?.filter((data) => data?.subSectionCode === subSection?.code)
        ?.find((data) => data.orderNumber === itemIndex)

      // Compute updated data (handle both function and direct value)
      let updatedItemData
      if (typeof updaterOrData === 'function') {
        updatedItemData = updaterOrData(targetItem)
      } else {
        updatedItemData = updaterOrData
      }

      // Return new list with updated item
      return fullSubSectionsList.map((data) => {
        if (data.subSectionCode === subSection?.code && data.orderNumber === itemIndex) {
          return {
            ...data,
            ...updatedItemData,
          }
        }
        return data
      })
    })
  }

  function addSubSectionItem() {
    if ((relevantSubSectionData || []).length >= maxItems) return
    const newItem = {
      subSectionCode: subSection?.code,
      subSectionLabel: subSection?.title,
      values: {},
      orderNumber: relevantSubSectionData.length,
    }
    setSubSectionsData((prevData) => {
      return [...(prevData || []), newItem]
    })
  }

  function removeItem(itemIndex) {
    setSubSectionsData((prevData) => {
      const relSubSectionData = prevData.filter((data) => data?.subSectionCode === subSection?.code)
      const itemToRemove = relSubSectionData.find((data) => data.orderNumber === itemIndex)
      if (!itemToRemove) return prevData
      return prevData.filter((data) => data !== itemToRemove)
    })
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">{subSection.title}</Typography>
        <Button
          variant="contained"
          size="small"
          onClick={addSubSectionItem}
          disabled={relevantSubSectionData.length >= maxItems}
        >
          Add New
        </Button>
      </Box>

      {relevantSubSectionData.length === 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', mb: 2 }}>
          No items yet. Click &quot;Add New&quot; to create one.
        </Typography>
      )}

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {relevantSubSectionData.map((subSectionDataItem, itemIndex) => (
          <Card key={itemIndex} variant="outlined">
            <CardContent>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 2,
                }}
              >
                {/* <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  {generateItemTitle({
                    currentSubSection: subSection,
                    item: subSectionDataItem,
                    itemIndex: itemIndex,
                    subSectionDataList: relevantSubSectionData,
                    itemTitleTemplate: subSection?.itemTitleTemplate,
                    sortedFields: sortedFields,
                  })}
                </Typography> */}
                <Button
                  variant="outlined"
                  size="small"
                  color="error"
                  onClick={() => removeItem(itemIndex)}
                  disabled={relevantSubSectionData.length <= minItems}
                >
                  Remove
                </Button>
              </Box>
              <GenericEmrSubSectionComponent
                setSubSectionsData={(setOrPrev) => setRelevantSubSectionData(setOrPrev, itemIndex)}
                subSection={subSection}
                subSectionData={subSectionDataItem}
                columns={subSection?.layoutConfig?.columns || 3}
                layout={subSection?.layoutConfig?.type || 'column'}
                spacing={subSection?.layoutConfig?.spacing || 2}
                practitionerRole={practitionerRole}
                runtime={runtime}
              />
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  )
}
